export enum WorkPosition {
  FIELD_OPERATOR = "FIELD_OPERATOR",
  TECHNICAL_ANALYST = "TECHNICAL_ANALYST",
  ASSISTANT = "ASSISTANT",
}